<script>
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';
import SlsEmbalagService from '@/services/SistemaDKP/sls-embalag.service';
import Swal from 'sweetalert2';
import { mapActions, mapGetters } from 'vuex';
import { BModal, BSpinner } from 'bootstrap-vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import axios from 'axios';
import { getTotvsBaseUrl } from '@/utils/totvsApi';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

const slsItemService = new SLSItemService();
const slsEmbalagemService = new SlsEmbalagService();
export default {
  name: 'ModalSelectedEmbalagens',
  components: {
    BModal,
    BSpinner,
    ECommerceProductDetails: () => import('@/views/app/CartECommerce/e-commerce-product-details/ECommerceProductDetails.vue'),
    InfoPedido: () => import('@/components/catalogo-produtos/InfoPedido.vue'),
  },
  data() {
    return {
      selected: null,
      show: false,
      gradeAtual: [],
      arrayEmbalagens: [],
      itemsCarrinho: [],
      isLoading: false,
      impostoLoading: false,
      impostoCalculado: null,
      produtosAdicionados: {},
    };
  },

  computed: {
    getInfoItem: {
      get() {
        return this.$store.getters['intensPedido/getFormData'];
      },
      set(value) {
        this.$store.commit('intensPedido/SET_DETALHES_ITEM', value);
      },
    },
    ...mapGetters('InfoPedido', [
      'GET_CLIENTE_DATA',
      'GET_ENDERECO_ENTREGA',
      'GET_DATA_CAPA_PEDIDO',
    ]),
    ...mapGetters('ItemStore', {
      json: 'GET_GRADE_ATUAL',
    }),
    ...mapGetters('ItemStore', {
      item: 'GET_CURRENT_ITEM',
    }),
    ...mapGetters('slsEmbalagem', {
      currentEmbalagem: 'getCurrentEsEmbalag',
    }),
    ...mapGetters('PedidosStore', {
      pedidoItens: 'getItemPedido',
    }),

  },
  methods: {
    ...mapActions('intensPedido', [
      'itensMarcaPedido',
      'itensCategoriaPedido',
      'itensReferenciaPedido',
      'itensEmbalagemPedido',
      'itensdetalhes',
      'setListTabelaItens',
      'clearModalItens',
      'buscaCorGradeItens',
      'setIsLoadingReferencia',
      'setIsLoadingReferenciaRestante',
    ]),
    async onSelectedEmbalagem() {
      this.isLoading = true;
      this.itemsCarrinho = [];
      this.impostoCalculado = null;

      try {
        let formData = this.$store.getters['InfoPedido/GET_VALIDATION_FORM_INFO_PEDIDO'];

        if (!formData) {
          const userId = this.getUserId();
          const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);

          if (savedFormData) {
            const parsedData = JSON.parse(savedFormData);

            this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', parsedData);

            this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
              clienteData: parsedData,
              enderecoEntrega: parsedData.enderecoEntrega,
              dataCapaPedido: {
                estabelecimentoid: parsedData.estabelecimento.estabelecimentoid,
                clientenomeabreviado: parsedData.cliente.clientenomeabreviado,
                naturezaoperacaoid: parsedData.naturezaOperacao?.naturezaoperacaoid || '6101',
                canal_venda_id: parsedData.canalVenda?.canal_venda_id || '',
                clienteisentoie: parsedData.cliente.clienteisentoie,
                tabelaprecoid: parsedData.tabelaPreco.tabelapreco_id,
                condicaopagamentoid: parsedData.condicaoPagamento.condicaopagamentoid,
              },
            });

            formData = true;
          } else {
            this.$refs.refModalTopSelectedEmbalagens.hide();
            await this.$bvModal.show('modal-center-info-pedido');
            return;
          }
        }

        this.$store.commit('InfoPedido/SET_IS_LOADING', false);

        const embalagensValues = this.$store.getters['slsEmbalagem/getEsEmbalg'];

        const itemSelected = this.$store.getters['InfoPedido/GET_ITEM_SELECTED'];
        const cliente = this.$store.getters['InfoPedido/GET_CLIENT_ID_ERP'];

        const itemImagem = {
          codMarca: itemSelected.cod_marca,
          codCateg: itemSelected.cod_categ,
          tabelaprecoId: this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id,
          clienteIderp: cliente.clienteiderp,
          familiaComercialId: itemSelected.familia_comercial_id,
        };

        const resposta = await this.itensdetalhes(itemImagem);

        if (resposta.success === false) {
          this.$refs.refModalTopSelectedEmbalagens.hide();
          await Swal.fire({
            icon: 'warning',
            title: 'Não encontrado',
            text: resposta.message,
          });
        }

        if (resposta === undefined) {
          this.$refs.refModalTopSelectedEmbalagens.hide();
          await Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: resposta.message,
          });
        } else {
          console.log('ITEM ENCONTRADO');
          const newGradeAtual = {
            embalagens: [],
          };
          this.gradeAtual = [];
          for (const embalagemValue of embalagensValues) {
            // console.log('itemSelected.cod_marca', itemSelected)
            console.log(itemSelected.cod_marca && itemSelected.cod_categ && this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id && itemSelected.familia_comercial_id);
            const hasRequiredData = (
              itemSelected.cod_marca !== null && itemSelected.cod_marca !== undefined
              && itemSelected.cod_categ !== null && itemSelected.cod_categ !== undefined
              && !!this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id
              && itemSelected.familia_comercial_id !== null && itemSelected.familia_comercial_id !== undefined
            );
            if (hasRequiredData) {
              console.log(
                'entrou no if',
              );
              /* PARA REQUISIÇÃO GET */
              const item = {
                codMarca: itemSelected.cod_marca,
                codCateg: itemSelected.cod_categ,
                tabelaprecoId: this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id,
                clienteIderp: cliente.clienteiderp,
                familiaComercialId: itemSelected.familia_comercial_id,
                cdnEmbalagem: embalagemValue.cdn_embalagem,
                codEmbal: embalagemValue.cdn_embalagem,
              };
              /* PARA REQUISIÇÃO POST */
              // const requestBody = {
              //   familiaComercialId: itemSelected.familia_comercial_id,
              //   codEmbal: embalagemValue.cdn_embalagem,
              //   codemitente: cliente.clienteiderp,
              //   nrtabpreco: 'BR24A'
              // };
              try {
                /* PARA REQUISIÇÃO GET */
                const baseUrl = await getTotvsBaseUrl();
                const url = `${baseUrl}/grade/${item.familiaComercialId}/${item.codEmbal}/${item.clienteIderp}/${this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id}`;
                const response = await fetch(url);

                /* PARA REQUISIÇÃO POST */
                // const url = `${baseUrl}/hbigrade`;
                // const response = await fetch(url, {
                //   method: 'POST',
                //   headers: {
                //     'Content-Type': 'application/json',
                //   },
                //   body: JSON.stringify(requestBody)
                // });

                if (!response.ok) {
                  throw new Error(`Erro na solicitação: ${response.statusText}`);
                }

                const data = await response.json();

                const tamanhoProps = [
                  'itemMultiploExtraGd',
                  'itemMultiploExtrapq',
                  'itemMultiploGrande',
                  'itemMultiploMedio',
                  'itemMultiploOutros',
                  'itemMultiploPequeno',
                  'itemMultiploSuperGd',
                  'itemMultiploUltraGd',
                  'itemMultiploUnico',
                ];

                const itemMultiplo = tamanhoProps
                  .map((prop) => data.dsHBIgrade.ttHBIgrade[0][prop])
                  .find((valor) => valor !== 0) || 0;

                newGradeAtual.embalagens.push({
                  descricao_embalagem: embalagemValue.des_embalag,
                  cdn_embalagem: embalagemValue.cdn_embalagem,
                  grade: data,
                  itemMultiplo,
                });
              } catch (error) {
                console.error('Erro ao fazer a solicitação:', error);
              }
            }
            this.gradeAtual.push(newGradeAtual);

            // console.log('GRADE ATUAL', this.gradeAtual);
          }

          this.$store.commit('ItemStore/SET_CURRENT_ITEM', this.getInfoItem.dataItensPedido);
          // this.$refs.refModalTopSelectedEmbalagens.hide()
          // this.$bvModal.show('modal-info-produto-id')
          this.selected = null;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async adicionarCarrinho() {
      try {
        const itemQtd = this.itemsCarrinho.filter((item) => item.pedido_item_quantidade > 0);
        if (itemQtd.length) {
          for (const item of itemQtd) {
            console.log('ITEM ENVIADOS AO CARRINHO', item);

            const existingItem = this.$store.getters['PedidosStore/getItemPedido'].find(
              (cartItem) => cartItem.item_id === item.item_id
                && cartItem.cdn_cor === item.cdn_cor
                && cartItem.cdn_tamanho === item.cdn_tamanho
                && cartItem.cdn_embalag === item.cdn_embalag
                && cartItem.familia_comercial_id === item.familia_comercial_id,
            );

            if (existingItem) {
              // Se o produto já existe, atualiza apenas a quantidade
              this.$store.commit('PedidosStore/UPDATE_ITEM_QUANTITY', {
                item: existingItem,
                quantity: existingItem.pedido_item_quantidade + item.pedido_item_quantidade,
              });
            } else {
              // Adiciona como novo item
              this.$store.commit('PedidosStore/ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', {
                ...item,
                pedido_item_seq: this.$store.getters['PedidosStore/getLastSequenceItemPedido'] + 10,
              });
            }
          }
          // this.$store.commit('ECommercerStore/ADD_OR_UPDATE_PRODUCT_TO_CART', {
          //   ...this.item,
          //   item_price: parseFloat(this.item.item_price),
          //   quantidade: 1
          // })
          this.$refs.refModalTopSelectedEmbalagens.hide();
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Falha',
              text: 'Obrigatorio Adicionar ao Menos um Produto.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }
      } catch (error) {
        console.error(error);
      }
    },
    onCancelModal() {
      this.mainImg = IMAGEM_PADRAO;
      this.$refs.refModalTopSelectedEmbalagens.hide();
    },
    handleRemoveItem(item) {
      console.log('REMOVENDO ITEM', item);
      this.itemsCarrinho = this.itemsCarrinho.filter((i) => i.item_id !== item.item_id && i.pedido_item_quantidade !== item.valor);
      console.log('CARRINHO ATUAL', this.itemsCarrinho);
    },

    updatedGrade(value) {
      console.log('updatedGradeItens', value);
      this.itemsCarrinho = value.map((item, index) => {
        console.log('THIS ITEM', this.item);
        // const imagem = this.item.imagens.find(img => img.cdnCor === item.cdn_cor)
        const imagemPrincipal = this.item.imagens.find((item) => item.imagemPrincipal === 1);
        const caminhoImagemPrincipal = imagemPrincipal ? imagemPrincipal.caminho : null;
        const precoBase = parseFloat(this.item.item_price_base ?? this.item.item_price);
        const precoExibicao = parseFloat(this.item.item_price_exibicao ?? this.item.item_price);
        const precoComImpostoItem = item.precoComImposto !== undefined ? item.precoComImposto : precoExibicao;

        return {
          index: this.pedidoItens.length + 1,
          cod_marca: this.item.cod_marca,
          familia_comercial_id: this.item.referencia,
          familia_comercial_descricao: this.item.item_name,
          cdn_cor: item.cdn_cor,
          cdn_tamanho: item.cdn_tamanho,
          des_tamanho: item.tamanho,
          des_cor: item.des_cor,
          item_id: item.item_id,
          item_descricao: `${this.item.referencia} - ${this.item.item_name}`,
          // item_imagem: imagem ? imagem.caminho : 'https://dkpsales-novo-hanes.s3.amazonaws.com/images/images/produto-sem-imagem.png',
          item_imagem: caminhoImagemPrincipal,
          pedido_item_seq: this.$store.getters['PedidosStore/getLastSequenceItemPedido'] + 10,
          pic_id: 0,
          marca: this.item.item_marca,
          embalagem: item.embalagem,
          cdn_embalag: item.cdn_embalag,
          pedido_item_preco_unitario: precoExibicao,
          pedido_item_preco_unitario_base: precoBase,
          pedido_item_quantidade: parseInt(item.valor, 10),
          valor_total: +(precoComImpostoItem * parseFloat(item.valor)),
          pedido_item_preco_total: +(precoComImpostoItem * parseFloat(item.valor)),
          precoComImposto: precoComImpostoItem,
          baseIcms: item.baseIcms,
          valorIcms: item.valorIcms,
          naturezaoperacaoidimposto: item.naturezaoperacaoidimposto,
          cliente: this.GET_CLIENTE_DATA.cliente.clientenomeabreviado,
          itemMultiplo: item.itemMultiplo,
        };
      });
      console.log('itemsCarrinho', this.itemsCarrinho);
    },
    async calcularImposto(newItem) {
      try {
        let clienteData = this.GET_CLIENTE_DATA;
        let enderecoEntrega = this.GET_ENDERECO_ENTREGA;
        let dataCapa = this.GET_DATA_CAPA_PEDIDO;

        if (!clienteData || !clienteData.estabelecimento) {
          const userId = this.getUserId();
          const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);

          if (savedFormData) {
            const parsedData = JSON.parse(savedFormData);

            this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', parsedData);

            clienteData = parsedData;
            enderecoEntrega = parsedData.enderecoEntrega;
            dataCapa = {
              estabelecimentoid: parsedData.estabelecimento.estabelecimentoid,
              clientenomeabreviado: parsedData.cliente.clientenomeabreviado,
              naturezaoperacaoid: parsedData.naturezaOperacao?.naturezaoperacaoid || '6101',
              canal_venda_id: parsedData.canalVenda?.canal_venda_id || '',
              clienteisentoie: parsedData.cliente.clienteisentoie,
              tabelaprecoid: parsedData.tabelaPreco.tabelapreco_id,
              condicaopagamentoid: parsedData.condicaoPagamento.condicaopagamentoid,
            };

            this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
              clienteData: parsedData,
              enderecoEntrega: parsedData.enderecoEntrega,
              dataCapaPedido: dataCapa,
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erro',
                text: 'Dados do cliente não encontrados. Por favor, selecione o cliente novamente.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            });
            return null;
          }
        }

        const baseUrl = await getTotvsBaseUrl();
        const url = `${baseUrl}/simular-Impostos-novo-metodo`;
        const data = {
          ttCabPedido: [{
            'c-pr-cod-estabel': clienteData.estabelecimento.estabelecimentoid,
            'c-pr-nome-abrev': clienteData.cliente.clientenomeabreviado,
            'c-pr-nat-operacao': clienteData.naturezaOperacao?.naturezaoperacaoid || '6101',
            'c-pr-cod-canal-venda': clienteData.canalVenda?.canal_venda_id || '',
            'c-pr-it-codigo': newItem.item_id,
            'd-pr-quantidade': newItem.valor,
            'd-pr-vl-preori-ped': this.item.item_price,
            'd-pr-per-des-item': 0.0000,
            'p-simulacao': 0,
            'p-uf-ds': enderecoEntrega.ufid,
            'p-cidade-ds': enderecoEntrega.clienteenderecocidade,
            'p-contr-icms': dataCapa.clienteisentoie ? 1 : 0,
            'p-tp-frete': 0,
            'p-tp-tabpre': dataCapa.tabelaprecoid,
            'p-cod-cond-pagto': Number(dataCapa.condicaopagamentoid),
            ttitempedido: [{
              itCodigo: newItem.item_id,
            }],
          }],
        };

        this.impostoLoading = true;
        const response = await axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.data.ttRetornoImposto && response.data.ttRetornoImposto[0]) {
          const precoImposto = response.data.ttRetornoImposto[0]['d-pr-unitario'] || 0;
          const valorBaseIcms = response.data.ttRetornoImposto[0]['d-pr-base-icms'] || 0;
          const valorIcms = response.data.ttRetornoImposto[0]['d-pr-valor-icms'] || 0;
          const naturezaoperacaoidimposto = response.data.ttRetornoImposto[0]['c-pr-nat-operacao'] || 0;

          return {
            precoComImposto: precoImposto,
            baseIcms: valorBaseIcms,
            valorIcms,
            naturezaoperacaoidimposto,
          };
        }

        return null;
      } catch (error) {
        console.error('Erro ao fazer a chamada à API:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao calcular impostos',
          timer: 2000,
        });
        return null;
      } finally {
        this.impostoLoading = false;
      }
    },
    getUserId() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData'));
        return userData?.id || 'default';
      } catch (error) {
        console.error('Erro ao obter ID do usuário:', error);
        return 'default';
      }
    },
  },
};
</script>

<template>
  <b-modal
    id="modal-top-selected-embalagens"
    ref="refModalTopSelectedEmbalagens"
    size="lg"
    hide-footer
    title="Adicionar Produto"
    modal-class="modal-add-product"
    @ok="onSelectedEmbalagem"
    @show="onSelectedEmbalagem"
    no-close-on-backdrop
  >
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 300px;">
      <b-spinner variant="primary" label="Carregando..."></b-spinner>
    </div>

    <div v-else class="modal-content-wrapper px-3 py-2">
      <!-- Client Info Bar -->
      <div v-if="GET_CLIENTE_DATA && GET_CLIENTE_DATA.cliente" class="client-info-bar">
        <div class="client-info">
          <feather-icon icon="UserIcon" size="16" />
          <div class="info-content">
            <span class="label">CLIENTE</span>
            <span class="value">{{ GET_CLIENTE_DATA.cliente.clientenomeabreviado || 'Cliente' }}</span>
          </div>
        </div>

        <div class="order-info">
          <div class="info-item" v-if="GET_DATA_CAPA_PEDIDO">
             <feather-icon icon="TagIcon" size="16" />
             <div class="info-content">
               <span class="label">TABELA</span>
               <span class="value">{{ GET_DATA_CAPA_PEDIDO.tabelaprecoid || '-' }}</span>
             </div>
          </div>
          <div class="info-item">
            <feather-icon icon="ShoppingCartIcon" size="16" />
            <div class="info-content">
               <span class="label">ITENS</span>
               <span class="value">{{ itemsCarrinho.length }}</span>
            </div>
          </div>
        </div>
      </div>

      <e-commerce-product-details
        :json="gradeAtual"
        :product="getInfoItem.dataItensPedido"
        is-modal
        v-model="getInfoItem.dataItensPedido.gradeItem"
        @remove-item="handleRemoveItem"
        @update:grade="updatedGrade"
        @calcular-imposto="calcularImposto"
      />

      <div class="modal-actions-footer">
        <div class="items-summary" v-if="itemsCarrinho.length > 0">
          <span class="summary-count">{{ itemsCarrinho.length }} item(s)</span>
          <span class="summary-separator">|</span>
          <span class="summary-total">{{ (itemsCarrinho.reduce((acc, curr) => acc + (curr.valor_total || 0), 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
        </div>
        <div class="actions-buttons" :class="{ 'ml-auto': itemsCarrinho.length === 0 }">
           <b-button variant="outline-secondary" @click="onCancelModal">
             <feather-icon icon="XIcon" size="16" class="mr-50" />
             Cancelar
           </b-button>
           <b-button variant="success" @click="adicionarCarrinho">
             <feather-icon icon="ShoppingCartIcon" size="16" class="mr-50" />
             Adicionar ao Pedido
           </b-button>
        </div>
      </div>
    </div>

  </b-modal>
</template>

<style scoped lang="scss">
.modal-add-product {
  --map-primary: var(--sf-accent, #7367f0);
}

.client-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--sf-accent, #7367f0);
  color: white;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;

  .client-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    feather-icon {
      opacity: 0.9;
    }
  }

  .order-info {
    display: flex;
    gap: 1.5rem;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .info-content {
    display: flex;
    flex-direction: column;
    line-height: 1.1;

    .label {
      font-size: 0.65rem;
      opacity: 0.8;
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .value {
      font-size: 0.85rem;
      font-weight: 600;
      color: white;
    }
  }
}

.modal-actions-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--sf-border-color, #e2e8f0);

  .items-summary {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: var(--sf-surface-secondary, #f8fafc);
    border-radius: 6px;

    .summary-count {
      font-weight: 600;
      color: var(--sf-accent, #7367f0);
      font-size: 0.9rem;
    }

    .summary-separator {
      color: var(--sf-border-color, #cbd5e1);
    }

    .summary-total {
      font-weight: 600;
      color: var(--sf-text-primary, #334155);
    }
  }

  .actions-buttons {
    display: flex;
    gap: 0.75rem;
  }
}

:global(body.dark-layout) {
  .client-info-bar {
    background: var(--sf-accent-dark, #5e50ee);
  }
}
</style>
